import APIclient from "API/Client";

export const getPermissionStatus = (resourceObj) => {
  const stringifyResorceObj = JSON.stringify(resourceObj);
  return APIclient.getData(`/ms/b2b-auth/v1/casbin/validate-permissions?permissions=${stringifyResorceObj}`);
};
